import { useModal } from '@shared/model/useModal';

export const useStudentModal = () => useModal('student')